import { z } from "zod";

const PRODUCT_MOUNTS = [
  "PRODUCT_OVERVIEW_CREATE",
  "PRODUCT_OVERVIEW_MORE_ACTIONS",
  "PRODUCT_DETAILS_MORE_ACTIONS",
  "PRODUCT_DETAILS_WIDGETS",
] as const;

const NAVIGATION_MOUNTS = [
  "NAVIGATION_CATALOG",
  "NAVIGATION_ORDERS",
  "NAVIGATION_CUSTOMERS",
  "NAVIGATION_DISCOUNTS",
  "NAVIGATION_TRANSLATIONS",
  "NAVIGATION_PAGES",
] as const;

const ORDER_MOUNTS = [
  "ORDER_DETAILS_MORE_ACTIONS",
  "ORDER_OVERVIEW_CREATE",
  "ORDER_DETAILS_WIDGETS",
  "DRAFT_ORDER_DETAILS_WIDGETS",
  "ORDER_OVERVIEW_MORE_ACTIONS",
] as const;

const CUSTOMER_MOUNTS = [
  "CUSTOMER_OVERVIEW_CREATE",
  "CUSTOMER_OVERVIEW_MORE_ACTIONS",
  "CUSTOMER_DETAILS_MORE_ACTIONS",
  "CUSTOMER_DETAILS_WIDGETS",
] as const;

const COLLECTION_MOUNTS = ["COLLECTION_DETAILS_WIDGETS"] as const;

const GIFT_CARD_MOUNTS = ["GIFT_CARD_DETAILS_WIDGETS"] as const;

const VOUCHER_MOUNTS = ["VOUCHER_DETAILS_WIDGETS"] as const;

export const ALL_APP_EXTENSION_MOUNTS = z.enum([
  ...PRODUCT_MOUNTS,
  ...NAVIGATION_MOUNTS,
  ...ORDER_MOUNTS,
  ...COLLECTION_MOUNTS,
  ...GIFT_CARD_MOUNTS,
  ...VOUCHER_MOUNTS,
  ...CUSTOMER_MOUNTS,
] as const);

// Subset of mounts available for WIDGET target
export const WIDGET_AVAILABLE_MOUNTS = [
  "ORDER_DETAILS_WIDGETS",
  "PRODUCT_DETAILS_WIDGETS",
  "VOUCHER_DETAILS_WIDGETS",
  "DRAFT_ORDER_DETAILS_WIDGETS",
  "GIFT_CARD_DETAILS_WIDGETS",
  "CUSTOMER_DETAILS_WIDGETS",
  "COLLECTION_DETAILS_WIDGETS",
] as const;
